export function SkeletonTimeline() {
  return (
    <div className="relative pl-7 pt-4 animate-pulse">
      <div className="absolute left-[9px] top-6 bottom-2 w-0.5 bg-gray-200" />

      {[0, 1, 2].map((i) => (
        <div key={i} className="relative pb-4 last:pb-0">
          {/* Dot */}
          <div className="absolute -left-7 top-0.5 w-5 h-5 rounded-full bg-gray-200" />

          {/* Content box */}
          <div className="bg-gray-50 rounded-md px-3.5 py-2.5 space-y-2">
            <div className="h-3.5 w-2/3 bg-gray-200 rounded" />
            <div className="h-3 w-1/2 bg-gray-200 rounded" />
            <div className="flex items-center gap-2">
              <div className="h-2.5 w-16 bg-gray-100 rounded" />
              <div className="w-[3px] h-[3px] rounded-full bg-gray-200" />
              <div className="h-2.5 w-20 bg-gray-100 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
